export default __webpack_public_path__ + "static/media/SG.eb1cb9e2.svg";